<template>
  <div class="reference-block scrollbar scrollbar--secondary">
    <div id="fact-rework_online_monitoring" class="reference-block-link" v-if="userCan('superadmin') || userCan('monitoring_read')">
      <router-link :to="{ name: 'rework_online_monitoring' }" class="links-item">
        <div class="link-flex">
            {{ getByHotSpotRouteTitleMenu('online_monitoring_new') }}
          <div v-if="isActiveHotSpot('online_monitoring_new')?.id" class="hotspot"
          @mouseenter="$store.dispatch('tooltip_store/SET_VIEW_TOOLTIP', {
              hoverEvent: $event,
              tooltipText: currentTooltipForHotSpot('online_monitoring_new'),
            })" 
          @mouseleave="$store.dispatch('tooltip_store/CLEAR_VIEW_TOOLTIP');">
          Новое
          </div>
          <div class="fact-rework_online_monitoring-new">
            новый
          </div>
        </div>
      </router-link>
    </div>
    <div id="fact-online_photo" class="reference-block-link" v-if="userCan('superadmin') || userCan('show_online_monitoring_photo')">
      <router-link :to="{ name: 'online_monitoring_photo' }" class="links-item">
        <div class="link-flex">
            {{ getByHotSpotRouteTitleMenu('online_monitoring_photo') }}
          <div v-if="isActiveHotSpot('online_monitoring_photo')?.id" class="hotspot"
          @mouseenter="$store.dispatch('tooltip_store/SET_VIEW_TOOLTIP', {
              hoverEvent: $event,
              tooltipText: currentTooltipForHotSpot('online_monitoring_photo'),
            })" 
          @mouseleave="$store.dispatch('tooltip_store/CLEAR_VIEW_TOOLTIP');">
          Новое
          </div>
        </div>
      </router-link>
    </div>
    <div id="fact-online_photo-beta" class="reference-block-link" v-if="userCan('superadmin') || userCan('show_online_monitoring_photo_beta')">
      <router-link :to="{ name: 'online_monitoring_photo_beta' }" class="links-item">
        <div class="link-flex">
            {{ getByHotSpotRouteTitleMenu('online_monitoring_photo_beta') }}
          <div v-if="isActiveHotSpot('online_monitoring_photo_beta')?.id" class="hotspot"
          @mouseenter="$store.dispatch('tooltip_store/SET_VIEW_TOOLTIP', {
              hoverEvent: $event,
              tooltipText: currentTooltipForHotSpot('online_monitoring_photo_beta'),
            })" 
          @mouseleave="$store.dispatch('tooltip_store/CLEAR_VIEW_TOOLTIP');">
          Новое
          </div>
        </div>
      </router-link>
    </div>
    <div id="fact-vehicle" class="reference-block-link" v-if="userCan('vehicle_read_all') || back_office">
      <router-link
        :to="{ name: 'vehicle' }"
        class="links-item"
      >
        <div class="link-flex">
            {{ getByHotSpotRouteTitleMenu('vehicle') }}
          <div v-if="isActiveHotSpot('vehicle')?.id" class="hotspot"
          @mouseenter="$store.dispatch('tooltip_store/SET_VIEW_TOOLTIP', {
              hoverEvent: $event,
              tooltipText: currentTooltipForHotSpot('vehicle'),
            })" 
          @mouseleave="$store.dispatch('tooltip_store/CLEAR_VIEW_TOOLTIP');">
          Новое
          </div>
        </div>
      </router-link>
    </div>
    <div id="fact-online_list" class="reference-block-link" v-if="userCan('online_list')">
      <router-link :to="{ name: 'online_list' }" class="links-item">
        <div class="link-flex">
            {{ getByHotSpotRouteTitleMenu('online_list') }}
          <div v-if="isActiveHotSpot('online_list')?.id" class="hotspot"
          @mouseenter="$store.dispatch('tooltip_store/SET_VIEW_TOOLTIP', {
              hoverEvent: $event,
              tooltipText: currentTooltipForHotSpot('online_list'),
            })" 
          @mouseleave="$store.dispatch('tooltip_store/CLEAR_VIEW_TOOLTIP');">
          Новое
          </div>
        </div>
      </router-link>
    </div>
    <div id="fact-monitoring_vehicle" class="reference-block-link" v-if="userCan('vehicle_monitoring')">
      <router-link :to="{ name: 'monitoring_vehicle' }" class="links-item">
      <div class="link-flex">
            {{ getByHotSpotRouteTitleMenu('monitoring_vehicle') }}
          <div v-if="isActiveHotSpot('monitoring_vehicle')?.id" class="hotspot"
          @mouseenter="$store.dispatch('tooltip_store/SET_VIEW_TOOLTIP', {
              hoverEvent: $event,
              tooltipText: currentTooltipForHotSpot('monitoring_vehicle'),
            })" 
          @mouseleave="$store.dispatch('tooltip_store/CLEAR_VIEW_TOOLTIP');">
          Новое
          </div>
        </div>
      </router-link>
    </div>

    <div id="fact-fgis-logs" class="reference-block-link" v-if="userCan('fgis_logs_show')">
      <router-link :to="{ name: 'fgis-logs' }" class="links-item">
      <div class="link-flex">
            {{ getByHotSpotRouteTitleMenu('fgis-logs') }}
          <div v-if="isActiveHotSpot('fgis-logs')?.id" class="hotspot"
          @mouseenter="$store.dispatch('tooltip_store/SET_VIEW_TOOLTIP', {
              hoverEvent: $event,
              tooltipText: currentTooltipForHotSpot('fgis-logs'),
            })" 
          @mouseleave="$store.dispatch('tooltip_store/CLEAR_VIEW_TOOLTIP');">
          Новое
          </div>
        </div>
      </router-link>
    </div>
    <div id="fact-link_to_fgis" class="reference-block-link" v-if="userCan('fgis_sync_manage')">
      <router-link :to="{ name: 'link_to_fgis' }" class="links-item">
        <div class="link-flex">
            {{ getByHotSpotRouteTitleMenu('link_to_fgis') }}
          <div v-if="isActiveHotSpot('link_to_fgis')?.id" class="hotspot"
          @mouseenter="$store.dispatch('tooltip_store/SET_VIEW_TOOLTIP', {
              hoverEvent: $event,
              tooltipText: currentTooltipForHotSpot('link_to_fgis'),
            })" 
          @mouseleave="$store.dispatch('tooltip_store/CLEAR_VIEW_TOOLTIP');">
          Новое
          </div>
        </div>
      </router-link>
    </div>
  </div> 
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    back_office: {
      required: true,
    }
  },
  data() {
    return {
      tooltipText: '',
      hoverEvent: null,
    };
  },
  computed: {
    ...mapGetters({
      userCan: "user/userCan",
      getByHotSpotRouteTitleMenu: "hotspots/getByHotSpotRouteTitleMenu",
      allListActiveHotSpots: "hotspots/allListActiveHotSpots",
    }),
  },
  methods: {
      isActiveHotSpot(menu) {
        const rusNameMenu = this.getByHotSpotRouteTitleMenu(menu)
        const result = this.allListActiveHotSpots.find(item => item.menu === rusNameMenu);
        return result;
      },
      currentTooltipForHotSpot(menu) {
        const hotSpot = this.isActiveHotSpot(menu);
        if (Object.entries(hotSpot).length &&  hotSpot.tooltip) {
          return hotSpot.tooltip
        } 
        return ''
      }
  }
};
</script>

<style lang="scss" scoped>
.reference-block {
  padding: 20px 25px;
  z-index: 1;
  display: grid;
  row-gap: 20px;
  position: absolute;
  top: 52px;
  left: 0;
  width: 398px;
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 566px;
  background: #1e6486;
  box-shadow: 4px 4px 8px 2px rgba(57, 134, 144, 0.5);
  border-radius: 5px;

  &::after {
    margin-top: 2px;
    z-index: -1;
    position: absolute;
    top: 0;
    left: 0;
    content: '';
    width: 398px;
    height: calc(100% - 2px);
    background: #1d7389;
    box-shadow: 4px 4px 8px 2px rgba(57, 134, 144, 0.5);
    border-radius: 5px;
  }

  &-link {
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #ffffff;
    height: 100%;

    & a {
      display: inline-block;
      width: 100%;
      height: 100%;
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      color: #ffffff;
    }

    &:hover {
      & a {
        color: #44ff8f;
      }
    }
  }
  .link-flex {
    display: flex;
    align-items: center
  }
}

#fact-rework_online_monitoring {
  position: relative;
}

.fact-rework_online_monitoring-new {
  position: absolute;
  top: 0;
  left: 165px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 24px;
  color: #ffffff;
  background-color: #FF7324;
  font-size: 12px;
  font-weight: 700;
  border-radius: 30px;
}
</style>